import axios from 'axios';

export default {
  namespaced: true,
  state: {
    isAuthorized: false,
    token: '',
    userName: ''
  },
  mutations: {
    auth_success(state, payload) {
      state.isAuthorized = true;
      state.token = payload.token;
      state.userName = payload.username;
    },
    auth_error(state) {
      state.isAuthorized = false;
    },
    logout(state) {
      state.token = '';
      state.isAuthorized = false;
      state.userName = '';
    },
    checkAuth(state) {
      var jwt = localStorage.getItem('token');
      if (jwt) {
        state.isAuthorized = true;
        state.token = jwt;
        state.userName = localStorage.getItem('userName');
      } else {
        state.isAuthorized = false;
      }
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios
          .post('/ADToken', user)
          .then(response => {
            const token = response.data.token;
            localStorage.setItem('token', token);
            localStorage.setItem('userName', user.username);
            axios.defaults.headers.common['Authorization'] = `bearer ${token}`;
            commit('auth_success', { token: token, username: user.username });
            resolve(response);
          })
          .catch(error => {
            commit('auth_error');
            localStorage.removeItem('token');
            localStorage.removeItem('userName');
            reject(error);
          });
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit('logout');
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        delete axios.defaults.headers.common['Authorization'];
        resolve();
      });
    },
    checkAuthAgainstAPI({ dispatch, state }) {
      return new Promise(() => {
        //if good result then auth is good
        axios
          .get('/ADToken/IsTokenAuthorized', {
            headers: { Authorization: `bearer ${state.token}` }
          })
          .then(
            () =>
              (axios.defaults.headers.common[
                'Authorization'
              ] = `bearer ${state.token}`)
          )
          .catch(() => dispatch('logout'));
      });
    }
  }
};
